import {wrapper} from "../../store/store";
import * as staticProps from '../../lib/static_props'
import {getStaticPropsWithoutCountry} from "../[countryCode]/merchants";
import MerchantsPage from '../[countryCode]/merchants'
import {withRedirectForNoCountryCode} from "../../components/with_redirect_for_no_country_code";

export const getStaticProps = wrapper.getStaticProps(store => async () => {
  await staticProps.populateServerSideStore(store.dispatch)
  return getStaticPropsWithoutCountry()
})

export default withRedirectForNoCountryCode(MerchantsPage)
